import React from 'react';

import { EyeIcon, PencilIcon, TrashIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { PolicyListResponsePolicyListItemModel } from '~/server_shared/openapi/data-contracts';
import { getLobDescription } from '~/Utils/lobUtils';

// Remove formatLobDisplay function since we'll use getLobDescription

export const createPolicyTableColumns = (
  onView: (policy: PolicyListResponsePolicyListItemModel) => void,
  onEdit: (policy: PolicyListResponsePolicyListItemModel) => void,
  onDelete: (policy: PolicyListResponsePolicyListItemModel) => void,
  policyLoadingNumber?: string | null,
  lobConfigurationsDict: Record<string, { desc?: string }> = {}
) => [
  {
    id: 'display_name',
    label: 'Display Name',
    numeric: false,
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => (
      <span className="text-gray-900 font-semibold">{policy.display_name || 'N/A'}</span>
    ),
  },
  {
    id: 'policy_number',
    label: 'Policy Number',
    numeric: false,
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => (
      <span className="text-gray-700 font-medium">{policy.policy_number || 'N/A'}</span>
    ),
  },
  {
    id: 'sub_organization_external_id',
    label: 'Sub-Organization',
    numeric: false,
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => (
      <span className="text-gray-600">{policy.sub_organization_external_id || 'Default'}</span>
    ),
  },
  {
    id: 'lob',
    label: 'LOB',
    numeric: false,
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => {
      // Use plain text like WorkflowEngine
      const lobValue = policy.lob || 'unknown';
      return getLobDescription(lobValue.replace('_policy', '_claim'), lobConfigurationsDict) || lobValue;
    },
  },
  {
    id: 'effective_date',
    label: 'Effective Date',
    numeric: false,
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => (
      <span className="text-gray-600">
        {policy.effective_date ? new Date(policy.effective_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  {
    id: 'actions',
    label: 'Actions',
    numeric: false,
    sortable: false,
    width: '120px', // Add explicit width like WorkflowEngine
    specialCell: (policy: PolicyListResponsePolicyListItemModel) => {
      const isLoading = policyLoadingNumber === policy.policy_uuid;
      return (
        <div className="gap-1 flex justify-center">
          <InlineIconButton
            icon={EyeIcon}
            tooltipTitle="View Policy"
            onClick={() => onView(policy)}
            disabled={isLoading}
            className="m-4 hover:cursor-pointer hover:text-teal-700"
            ignorePermissions
            iconColor="currentColor"
          />
          <InlineIconButton
            icon={PencilIcon}
            tooltipTitle="Edit Policy"
            onClick={() => onEdit(policy)}
            disabled={isLoading}
            className="m-4 hover:cursor-pointer hover:text-teal-700"
            ignorePermissions
            iconColor="currentColor"
          />
          <InlineIconButton
            icon={TrashIcon}
            tooltipTitle="Delete Policy"
            onClick={() => onDelete(policy)}
            disabled={isLoading}
            className="m-4 hover:cursor-pointer hover:text-teal-700"
            ignorePermissions
            iconColor="currentColor"
          />
        </div>
      );
    },
  },
];
